import { render } from "./ModalDetailTicket.vue?vue&type=template&id=c7a1f9ba&scoped=true"
import script from "./ModalDetailTicket.vue?vue&type=script&lang=js"
export * from "./ModalDetailTicket.vue?vue&type=script&lang=js"

import "./ModalDetailTicket.vue?vue&type=style&index=0&id=c7a1f9ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7a1f9ba"]])

export default __exports__